import { ContentData } from '../../../types/contentTypes';
import SectionData from '../../../types/SectionData';
import SkillData from '../../../types/skillData';
import ContentList from '../../molecules/content-list/ContentList';
import SectionList from '../../molecules/skill-list/SectionList';

interface CreationProgressSidebarContentProps {
  skill: SkillData;
  sections?: SectionData[];
  contents?: (ContentData | undefined)[];
  handleSwapOrder?: (sections: SectionData[] | ContentData[], index1: number, index2: number) => {};
}

export function CreationProgressSidebarContent({
  skill,
  sections,
  contents,
  handleSwapOrder,
}: CreationProgressSidebarContentProps) {
  return (
    <div className="h-full overflow-y-scroll py-6">
      {sections && (
        <div className="mb-8">
          <p className="tertiary-heading px-8">Sections</p>
          <SectionList
            sections={sections}
            skill={skill}
            handleSwapOrder={!contents ? handleSwapOrder : undefined}
            isDraggable={!contents}
            editing
          />
        </div>
      )}
      {contents && (
        <div>
          <p className="tertiary-heading py-2 px-8">Contents</p>
          <ContentList className="px-8" contents={contents} handleSwapOrder={handleSwapOrder} />
        </div>
      )}
    </div>
  );
}
